import Paragraph from '@components/UI/Typography/Paragraph';
import useMods from '@hooks/useMods';

import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

const FileUploaderDrag = forwardRef(({ mods={} }, ref) => {
    const { className } = useMods(FileUploaderDrag, { mods });

    return (
        <div
            className={ className }
            ref={ ref }
        >
            <Paragraph
                tag='p'
                size='sm'
            >
                +Add File
            </Paragraph>
        </div>
    );
});

FileUploaderDrag.displayName = 'File-Uploader-Drag';

FileUploaderDrag.propTypes = {
    mods: PropTypes.object
};

export default FileUploaderDrag;
